import styled from 'styled-components';
import { BodyBoldS, HeadingExtraBoldM } from '../../styles/globals';

export const DonutChartCont = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    .recharts-sector {
      cursor: pointer;
      transition: all 0.2s ease-in-out;
    }
  }
`;

export const ResultTextCont = styled(HeadingExtraBoldM)`
  position: absolute;
  display: flex;
  margin: auto;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;

export const ShareResult = styled.span``;

export const CountResult = styled(BodyBoldS)``;
